var _rect, _path, _g, _rect2, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHornbachAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4478_1201)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_4478_1201)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4478_1201)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 71,
    height: 71,
    rx: 8,
    fill: "#C40070"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4478_1201",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 72,
    height: 71
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.00011H71.4996V71.9973H0.5V1.00011Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4478_1201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.7498 78.3195L76.5382 -8.92441L81.4072 -4.06214L-5.88083 83.1819L-10.7498 78.3195Z",
    fill: "#F7911A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.0477 71.0323L69.2403 -16.2122L74.1102 -11.3491L-13.1778 75.895L-18.0477 71.0323Z",
    fill: "#F7911A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.3439 63.7458L61.9432 -23.4988L66.8122 -18.6356L-20.4749 68.6082L-25.3439 63.7458Z",
    fill: "#F7911A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32.6418 56.4589L54.6462 -30.7854L59.5152 -25.9231L-27.7719 61.3213L-32.6418 56.4589Z",
    fill: "#F7911A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.052 120.835L48.6801 33.5908L53.55 28.7224L140.921 115.967L136.052 120.835Z",
    fill: "#F7911A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.754 128.129L41.3829 40.8846L46.2528 36.0171L133.623 123.261L128.754 128.129Z",
    fill: "#F7911A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.457 135.424L34.086 48.1792L38.9551 43.3115L126.327 130.556L121.457 135.424Z",
    fill: "#F7911A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.16 142.718L26.7881 55.4735L31.658 50.6058L119.029 137.85L114.16 142.718Z",
    fill: "#F7911A"
  })))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4478_1201)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#C40070"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4478_1201",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 32,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H51.9998V51.9988H20V20Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4478_1201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9297 54.8482L54.2708 15.527L56.4652 17.7184L17.1241 57.0397L14.9297 54.8482Z",
    fill: "#F7911A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6405 51.5637L50.9816 12.2422L53.1765 14.4341L13.8354 53.7554L11.6405 51.5637Z",
    fill: "#F7911A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35202 48.2797L47.6927 8.95821L49.8872 11.15L10.5465 50.4712L8.35202 48.2797Z",
    fill: "#F7911A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.06284 44.9955L44.4039 5.67415L46.5984 7.86559L7.25773 47.187L5.06284 44.9955Z",
    fill: "#F7911A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0937 74.0101L41.715 34.6888L43.9099 32.4946L83.2882 71.8162L81.0937 74.0101Z",
    fill: "#F7911A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8049 77.2974L38.4261 37.9761L40.621 35.7823L79.9994 75.1036L77.8049 77.2974Z",
    fill: "#F7911A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5157 80.5853L35.1374 41.2639L37.3319 39.07L76.7106 78.3915L74.5157 80.5853Z",
    fill: "#F7911A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2269 83.8728L31.8482 44.5513L34.0431 42.3574L73.4214 81.6789L71.2269 83.8728Z",
    fill: "#F7911A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4478_1201",
    x: -9.5,
    y: -9,
    width: 91,
    height: 91,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_4478_1201"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4478_1201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4478_1201"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 71,
    height: 71,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4478_1201"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHornbachAppIcon);
export default __webpack_public_path__ + "static/media/hornbach-app-icon.208696b2294e7bf4748ff8f2727760a1.svg";
export { ForwardRef as ReactComponent };